import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { EpaApi } from '../../../../services'
import { WaterSystemCoordinatesInitialState } from '../waterSystemCoordinates.slice'

export const createWaterSystemCoordinatesAsync = createAsyncThunk(
  'coordinates/waterSystemCoordinates',
  async ({ waterSystemIds, includeTransient }: { waterSystemIds: string[], includeTransient?: boolean }, { rejectWithValue }) => {
    try {
      const options = {
        params: {
          include_transient: includeTransient ? 'true' : 'false',
        },
      }
      const req = await EpaApi.createWaterSystemCoordinates(waterSystemIds, options)
      return (req as AxiosResponse<any, any>).data
    } catch (error: any) {
      console.error(error)
      return rejectWithValue({message:"unknown error occured"})
    }
  },
)

export const createWaterSystemCoordinatesAsyncBuilder = (
  builder: ActionReducerMapBuilder<WaterSystemCoordinatesInitialState>,
) => {
  builder.addCase(createWaterSystemCoordinatesAsync.pending, (state, action) => {
    state.loading = true
    state.success = false
    state.error = ''
  })
  builder.addCase(createWaterSystemCoordinatesAsync.fulfilled, (state, action: PayloadAction<any>) => {
    state.loading = false
    state.success = true
    state.data = action.payload
  })
  builder.addCase(createWaterSystemCoordinatesAsync.rejected, (state, action: PayloadAction<any>) => {
    state.loading = false
    state.success = true
    state.error = action.payload
  })
}
